import React from 'react';
import { Tabs } from 'antd';
import { useCompetition } from "../../../base-react/hooks/Competition";
import { useParams, useNavigate, useLocation, Outlet } from "react-router-dom";
import { Loading } from '../../../base-react/components/Loading';
const { TabPane } = Tabs;
export const CompetitionOutlet = () => {
    const { event_id, competition_id } = useParams();
    const [inputCompetition, event, competitions, loading] = useCompetition(competition_id);
    const navigate = useNavigate();
    const location = useLocation();
    if (loading) {
        return React.createElement(Loading, null);
    }
    const onChangeTab = (activeKey) => {
        const newPath = location.pathname.replace(competition_id, activeKey);
        navigate({
            pathname: newPath,
            search: location.search
        });
    };
    if (competitions && competitions.length > 0) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Tabs, { onChange: onChangeTab, defaultActiveKey: competition_id, tabBarStyle: { margin: 24 } }, competitions.map((competition) => (React.createElement(TabPane, { tab: competition.competition_name, key: competition.competition_id },
                React.createElement(Outlet, null)))))));
    }
    return React.createElement(Outlet, null);
};
